export class Descuento {
    public MontoDescuento?: number;
    public NaturalezaDescuento?: string;
}
